export const schemaString = (
    date: string,
    options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    },
    lang: string = "en-US",
) => {
    return new Date(date).toLocaleDateString(lang, options);
};

export const getSeoOptions = (content, model) => {
    const seo = content.data?.seo?.seo || false
    const title = getTitle(seo, content, model)
    const description = getDescription(seo, content, model)
    const image = getImage(seo, content, model)
    const breadcrumbs = {}

    const options = {
        title,
        description,
        webpage: {
            datePublished: schemaString(content?.firstPublished) || false,
            dateModified: schemaString(content?.lastUpdated) || false,
            image,
        }
    };

    return options;
};

const getTitle = (seo, content, model) => {
    if (seo?.title && seo.title.trim() != '') return seo.title;
    // Page Title
    let title = content?.data?.title || content?.name;
    switch (model || '') {
        case 'buildings':
            title = content?.data?.buildingName || title;
            title = content?.data?.officialName || title;
            break;
        case 'team-members':
            const name = content?.data?.name;
            const jobTitle = content?.data?.title;
            let newTitle = title;
            if (name) newTitle = name;
            if (name && jobTitle) newTitle = `${name} - ${jobTitle}`;
            title = newTitle;
            break;
    }
    // Fail Safe, get Builder Page Name
    if (!title) title = content.data?.name;
    return title;
};

const getDescription = (seo, content, model) => {
    if (seo?.description && seo.description.trim() != '') return seo.description;
    let description = content.data?.description || content.data?.shortDescription;
    switch (model || '') {
        case 'team-members':
            description = content.data?.bio || description;
            break;
        case 'tours':
            if (!description) description = content?.data?.blurb;
            break;
    }
    return description;
};

const getImage = (seo, content, model) => {
    if (seo?.shareImage && seo.shareImage.trim() !== '') return seo.shareImage;
    let image = '/social.jpg';
    switch (model || '') {
        case 'architecture-encyclopedia-articles':
            image = content.data?.image || image;
            image = content.data?.imageList?.[0]?.src || image;
            break;
        case 'buildings':
            image = content.data?.imageList?.[0]?.src || image;
            break;
        case 'exhibitions':
            image = content.data?.cardOnlyImage || image;
            image = content.data?.featuredImages?.[0]?.image || image;
            break;
        case 'programs-events':
            image = content?.data?.imageList?.[0]?.image || image;
            break;
        case 'resources':
            image = content?.data?.image || image;
            break;
        case 'team-members':
            image = content?.data?.image || image;
            break;
        case 'stories':
            image = content?.data?.image?.src || image;
            break;
        case 'tours':
            image = content?.data?.gallery?.[0]?.image || image;
            break;
        case 'page':
            image = content?.data?.blocks?.length > 0 && content?.data?.blocks[0].component?.options?.image ? content?.data?.blocks[0].component?.options?.image?.src : image
            break
    }
    return image;
};
